<template>
  <!-- 确认提示框-组件 -->
  <div style="position: absolute; top: 0; right: 0; left: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.2);" v-if="visible">
    <div style="position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0;  padding-bottom:54px; width: 320px; border-radius: 2px; background-color: #ffffff; box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);"
    :style="{'padding-top':config.title? '30px' :0, height:config.title? '128px' :'128px'}">
      <p style="position: absolute; top:10px; left:0; width:100%; padding: 0px 16px; font-size: 16px; line-height: 20px; width: 100%;" v-show="config.title">{{config.title}}</p>
      <div style="height:100%; padding: 15px 16px 10px 16px; overflow:auto;">
          <p >{{message}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      def_config: {
        title: '提示',
        message: ''
      },
      config: {
        title: null,
        message: null
      },
      visible: false,
      message:''
    }
  },
  methods: {
    open: function (config) {
      console.log('config',config);
      this.message = config.message||'成功'
      if (this.visible || !config) return;
      this.visible = true;
      setTimeout(()=>{
        this.visible = false;
      },2000)
    },
    close: function () {
      this.visible = false;
    }
  }
}
</script>
